const initialState = {
    findMyContacts: null,
	stopFindingNextMyContacts: false,
    myContactsPageSize: 100,
    myContactsPageNumber: 1,
	findContacts: null,
	isNewContactsLoading: false,
    contactsPageSize: 100,
    contactsPageNumber: 1,
    contactsLetter: '',
    targetedContact: null,
	selectedContacts: [],
    selectedContactFromDrag: [],
    labelsOfSelectedContacts: [],
	searchResultValue:false,
    selectContactToAdd: [],
    selectLabelToAdd: [],
    userContactType: "contact",
    contactSearchResult: {
        contacts: []
    },
    contactSearchResultPageSize: 50,
	contactSearchResultPageNumber: 1,
    commentToAddContactSearchResult: {
        contacts: []
    },
    commentToEditContactSearchResult: {
        contacts: []
    },
    modalContactSearchResult: {
        contacts: []
    },
    keepOnContacts: true,
    enteredContactSearchValue: '',
    enteredModalContactSearchValue: '',
	isLoadingContacts: true,
    isSearchResultsDropDownShown: false,
    isSearchingContacts: false,
    confirmContactResearch: false,
    contactDetailsEditMode: false,
    extendAddContactBtn: false,
    contactCardDetails:{},
	isContactsAdvancedSearchDropDown: false,
	contactsAdvancedSearchRequest: null,
	isContactsSearchAdvancedMode: false,
	loadNextContacts: false
};

const contactReducer = ( state = initialState, action ) => {
	switch (action.type) {
        case "FIND_MY_CONTACTS":
            state = {
                ...state,
                findMyContacts: action.payload
            };
            break;
		case "FIND_NEXT_MY_CONTACTS":
			state = {
				...state,
				findMyContacts: {
					...state.findMyContacts,
					contacts: [
						...state.findMyContacts.contacts,
						...action.payload.contacts
					]
				}
			};
			break;
		case "STOP_FINDING_NEXT_MY_CONTACTS":
			state = {
				...state,
				stopFindingNextMyContacts: action.payload
			};
			break;
        case "MY_CONTACTS_PAGE_SIZE":
            state = {
                ...state,
                myContactsPageSize: action.payload
            };
            break;
        case "USER_CONTACT_TYPE":
            state = {
                ...state,
                userContactType: action.payload
            };
            break;
        case "MY_CONTACTS_PAGE_NUMBER":
            state = {
                ...state,
                myContactsPageNumber: action.payload
            };
            break;
        case "FIND_CONTACTS":
            state = {
                ...state,
                findContacts: action.payload
            };
            break;
		case "FIND_NEXT_CONTACTS":
			state = {
				...state,
				findContacts: {
					...state.findContacts,
					contacts: [
						...state.findContacts.contacts,
						...action.payload.contacts
					]
				}
			};
			break;
		case "IS_NEW_CONTACTS_LOADING":
			state = {
				...state,
				isNewContactsLoading: action.payload
			};
			break;
        case "REFRESH_CONTACTS":
            state = {
                ...state,
                findContacts: {
                    ...state.findContacts,
                    contacts: [...state.findContacts.contacts, ...action.payload]
                }
            };
            break;
        case "SEARCH_RESULT":
            state = {
                ...state,
                searchResultValue:action.payload
            };
            break;
        case "CONTACTS_PAGE_SIZE":
            state = {
                ...state,
                contactsPageSize: action.payload
            };
            break;
        case "CONTACTS_PAGE_NUMBER":
            state = {
                ...state,
                contactsPageNumber: action.payload
            };
            break;
        case "CONTACTS_LETTER":
            state = {
                ...state,
                contactsLetter: action.payload
            };
            break;
        case "TARGETED_CONTACT":
            state = {
                ...state,
                targetedContact: action.payload
            };
            break;
		case "SELECTED_CONTACTS":
			state = {
				...state,
				selectedContacts: action.payload
			};
			break;
        case "SELECTED_CONTACT_FROM_DRAG":
            state = {
                ...state,
                selectedContactFromDrag: action.payload
            };
            break;
        case "LABELS_OF_SELECTED_CONTACTS":
            state = {
                ...state,
                labelsOfSelectedContacts: action.payload
            };
            break;
        case "SELECT_LABEL_TO_ADD":
            state = {
                ...state,
                selectLabelToAdd: action.payload
            };
            break;
        case "SELECT_CONTACT_TO_ADD":
            state = {
                ...state,
                selectContactToAdd: action.payload
            };
            break;
        case "CONTACTS_SEARCH_RESULT":
            state = {
                ...state,
                contactSearchResult: action.payload
            };
            break;
        case "CONTACTS_SEARCH_RESULT_PAGE_SIZE":
            state = {
                ...state,
                contactSearchResultPageSize: action.payload
            };
            break;
		case "CONTACTS_SEARCH_RESULT_PAGE_NUMBER":
			state = {
				...state,
				contactSearchResultPageNumber: action.payload
			};
			break;
        case "COMMENT_TO_ADD_CONTACTS_SEARCH_RESULT":
            state = {
                ...state,
                commentToAddContactSearchResult: action.payload
            };
            break;
        case "COMMENT_TO_EDIT_CONTACTS_SEARCH_RESULT":
            state = {
                ...state,
                commentToEditContactSearchResult: action.payload
            };
            break;
        case "MODAL_CONTACTS_SEARCH_RESULT":
            state = {
                ...state,
                modalContactSearchResult: action.payload
            };
            break;
        case "KEEP_ON_CONTACTS":
            state = {
                ...state,
                keepOnContacts: action.payload
            };
            break;
        case "ENTERED_CONTACT_SEARCH_VALUE":
            state = {
                ...state,
                enteredContactSearchValue: action.payload
            };
            break;
        case "ENTERED_MODAL_CONTACT_SEARCH_VALUE":
            state = {
                ...state,
                enteredModalContactSearchValue: action.payload
            };
            break;
		case "IS_LOADING_CONTACTS":
			state = {
				...state,
				isLoadingContacts: action.payload
			};
			break;
        case "IS_SEARCH_RESULTS_DROPDOWN_SHOWN":
            state = {
                ...state,
                isSearchResultsDropDownShown: action.payload
            };
            break;
        case "IS_SEARCHING_CONTACTS":
            state = {
                ...state,
                isSearchingContacts: action.payload
            };
            break;
        case "CONFIRM_CONTACT_RESEARCH":
            state = {
                ...state,
                confirmContactResearch: action.payload
            };
            break;
        case "CONTACT_DETAILS_EDIT_MODE":
            state = {
                ...state,
                contactDetailsEditMode: action.payload
            };
            break;
        case "EXTEND_ADD_CONTACT_BTN":
            state = {
                ...state,
                extendAddContactBtn: action.payload
            };
            break;
		case "CONTACTCARD_DETAILS":
			state = {
				...state,
				contactCardDetails:action.payload
			};
			break;
		case "IS_CONTACTS_ADVANCED_SEARCH_DROP_DOWN":
			state = {
				...state,
				isContactsAdvancedSearchDropDown: action.payload
			};
			break;
		case "CONTACTS_ADVANCED_SEARCH_REQUEST":
			state = {
				...state,
				contactsAdvancedSearchRequest: action.payload
			};
			break;
		case "IS_CONTACTS_SEARCH_ADVANCED_MODE":
			state = {
				...state,
				isContactsSearchAdvancedMode: action.payload
			};
			break;
        case "IS_UPDATE_TO_BUSINESS_SHOWN":
			state = {
				...state,
				isUpgradeToBusinessShown: action.payload
			};
			break;
        case "IS_UPDATE_TO_BUSINESS_SHOWN_AND_ACTIVATED":
			state = {
				...state,
				isUpgradeToBusinessShownAndActivated: action.payload
			};
			break;
		case "LOAD_NEXT_CONTACTS":
			state = {
				...state,
				loadNextContacts: action.payload
			};
			break;
		default:
            break;
	}
	return state;
};

export default contactReducer;
